let baseUrl = ''

switch (location.hostname) {
    /* 测试环境 */
    case 'test_enterprise.zjtoutiao.cn':
        baseUrl = "https://test_api.zjtoutiao.cn/";
        break;
    case 'www.zjtoutiao.cn':
        baseUrl = "https://test_api.zjtoutiao.cn/";
        break;
    /* 正式环境 */
    case 'enterprise.xixunyun.cn':
        baseUrl = "https://api.xixunyun.cn/";
        break;
    case 'xixunyun.cn':
        baseUrl = "https://api.xixunyun.cn/";
        break;
    case 'www.xixunyun.cn':
        baseUrl = "https://api.xixunyun.cn/";
        break;
    case 'qiye.xixunyun.cn':
        baseUrl = "https://api.xixunyun.cn/";
        break;
    case 'yunnan_qiye.xixunyun.cn':
        baseUrl = "https://api.xixunyun.cn/";
        break;
    default:
        baseUrl = "https://api.qxiaoyun.com/";
        // baseUrl = "https://test_api.zjtoutiao.cn/";
}

export default baseUrl;